import React from 'react';
import { func, shape } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Topbar } from '../../components';
import config from '../../config/config';

const TopbarContainer = ({ history, onManageDisableScrolling, ...rest }) => (
  <Topbar
    history={history}
    onManageDisableScrolling={onManageDisableScrolling}
    config={config}
    {...rest}
  />
);

TopbarContainer.propTypes = {
  history: shape({
    push: func.isRequired,
  }).isRequired,
  onManageDisableScrolling: func.isRequired,
};

export default withRouter(TopbarContainer);
